import * as React from 'react';
import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid,
    TextField, EditButton,
    useNotify, useDelete,
    ListProps, Button as RAButton,
    useRecordContext
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IDirectoryCategory } from '../types/types';
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<IDirectoryCategory>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('directorycategories', { id: record.id });
        notify('resources.directorycategories.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Category' }
        });
        setOpen(false);
    };

    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this directory category?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export const DirectoryCategoryList: FC<ListProps> = (props) => {
    useAuthorize([UserRole.Admin]);
    return (
        <List {...props}>
            <Datagrid>
                <TextField source="category_name" label="Category Name" />
                <TextField source="category_description" label="Description" />
                <EditButton />
                <DeleteWithConfirmButton />
            </Datagrid>
        </List>
    );
};
